import { createClient } from '../../client/createClient'
import { createSubscan } from '../../explorer'
import type { Chain } from '../types'

type CreateAssetHubChainParameters = {
  explorerApiKey?: string
  explorerProxyUrl?: string
  rpcEndpoints?: string[]
}

export const createAssetHubChain = ({
  explorerApiKey,
  explorerProxyUrl,
  rpcEndpoints = assetHubWebsocketRpcUrls,
}: CreateAssetHubChainParameters): Chain => {
  return {
    /** {@link https://polkadot.subscan.io/parachain_list?status=parachain} */
    id: 1000,
    /** {@link https://github.com/paritytech/ss58-registry/blob/main/ss58-registry.json} */
    ss58Prefix: 0,
    network: 'asset-hub-polkadot',
    name: 'AssetHub (Polkadot)',
    blockTimeSeconds: 3,
    nativeToken: {
      name: 'Polkadot',
      symbol: 'DOT',
      decimals: 10,
      currency: {
        symbol: 'DOT',
        type: 'CryptoCurrency',
        id: 'polkadot',
        name: 'Polkadot',
        updatedAt: 0,
      },
    },
    client: createClient(rpcEndpoints),
    explorer: createSubscan({
      name: 'Subscan',
      baseUrl: 'https://assethub-polkadot.subscan.io',
      networkName: 'assethub-polkadot',
      apiKey: explorerApiKey,
      proxyUrl: explorerProxyUrl,
    }),
    rpcEndpoints,
    assetType: 'assets',
    /** {@link https://assethub-polkadot.subscan.io/asset_token?page=1&order=desc&order_field=holders} */
    assetMap: new Map([
      [
        30n,
        {
          asset: {
            symbol: 'DED',
            type: 'CryptoCurrency',
            id: 'dot-is-ded',
            name: 'DED',
            updatedAt: 0,
          },
          decimals: 10,
        },
      ],
      [
        1984n,
        {
          asset: {
            symbol: 'USDT',
            type: 'CryptoCurrency',
            id: 'tether',
            name: 'Tether',
            updatedAt: 0,
          },
          decimals: 6,
        },
      ],
      [
        1337n,
        {
          asset: {
            symbol: 'USDC',
            type: 'CryptoCurrency',
            id: 'usd-coin',
            name: 'USDC',
            updatedAt: 0,
          },
          decimals: 6,
        },
      ],
      [
        23n,
        {
          asset: {
            symbol: 'PINK',
            type: 'CryptoCurrency',
            id: 'dot-finance',
            name: 'Dot Finance',
            updatedAt: 0,
          },
          decimals: 10,
        },
      ],
      [
        1024n,
        {
          asset: {
            symbol: 'NCTR',
            type: 'CryptoCurrency',
            id: 'apillon',
            name: 'Apillon',
            updatedAt: 0,
          },
          decimals: 18,
        },
      ],
    ]),
  }
}

export const assetHubWebsocketRpcUrls = [
  'wss://asset-hub-polkadot-rpc.dwellir.com',
  'wss://statemint-rpc-tn.dwellir.com',
  'wss://sys.ibp.network/asset-hub-polkadot',
  'wss://asset-hub-polkadot.dotters.network',
  'wss://rpc-asset-hub-polkadot.luckyfriday.io',
  'wss://statemint.api.onfinality.io/public-ws',
  'wss://polkadot-asset-hub-rpc.polkadot.io',
  'wss://statemint.public.curie.radiumblock.co/ws',
  'wss://dot-rpc.stakeworld.io/assethub',
]
